function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import { first } from 'ckeditor5/src/utils';
/**
 * @module image/imagestyle/converters
 */

/**
 * Returns a converter for the `imageStyle` attribute. It can be used for adding, changing and removing the attribute.
 *
 * @param {Array.<module:image/imagestyle~ImageStyleOptionDefinition>} styles
 * An array containing available image style options.
 * @returns {Function} A model-to-view attribute converter.
 */

export function modelToViewStyleAttribute(styles) {
  return function (evt, data, conversionApi) {
    if (!conversionApi.consumable.consume(data.item, evt.name)) {
      return;
    } // Check if there is class name associated with given value.


    var newStyle = getStyleDefinitionByName(data.attributeNewValue, styles);
    var oldStyle = getStyleDefinitionByName(data.attributeOldValue, styles);
    var viewElement = conversionApi.mapper.toViewElement(data.item);
    var viewWriter = conversionApi.writer;

    if (oldStyle) {
      viewWriter.removeClass(oldStyle.className, viewElement);
    }

    if (newStyle) {
      viewWriter.addClass(newStyle.className, viewElement);
    }
  };
}
/**
 * Returns a view-to-model converter converting image CSS classes to a proper value in the model.
 *
 * @param {Array.<module:image/imagestyle~ImageStyleOptionDefinition>} styles
 * Image style options for which the converter is created.
 * @returns {Function} A view-to-model converter.
 */

export function viewToModelStyleAttribute(styles) {
  // Convert only non–default styles.
  var nonDefaultStyles = {
    imageInline: styles.filter(function (style) {
      return !style.isDefault && style.modelElements.includes('imageInline');
    }),
    imageBlock: styles.filter(function (style) {
      return !style.isDefault && style.modelElements.includes('imageBlock');
    })
  };
  return function (evt, data, conversionApi) {
    if (!data.modelRange) {
      return;
    }

    var viewElement = data.viewItem;
    var modelImageElement = first(data.modelRange.getItems()); // Check if `modelImageElement` exists (see: #8270, and #9563)...

    if (!modelImageElement) {
      return;
    } // ...and the `imageStyle` attribute is allowed for that element, otherwise stop conversion early.


    if (!conversionApi.schema.checkAttribute(modelImageElement, 'imageStyle')) {
      return;
    } // Convert styles one by one.


    var _iterator = _createForOfIteratorHelper(nonDefaultStyles[modelImageElement.name]),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var style = _step.value;

        // Try to consume class corresponding with the style.
        if (conversionApi.consumable.consume(viewElement, {
          classes: style.className
        })) {
          // And convert this style to model attribute.
          conversionApi.writer.setAttribute('imageStyle', style.name, modelImageElement);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };
} // Returns the style with a given `name` from an array of styles.
//
// @param {String} name
// @param {Array.<module:image/imagestyle~ImageStyleOptionDefinition> } styles
// @returns {module:image/imagestyle~ImageStyleOptionDefinition|undefined}

function getStyleDefinitionByName(name, styles) {
  var _iterator2 = _createForOfIteratorHelper(styles),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var style = _step2.value;

      if (style.name === name) {
        return style;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
}